module.exports = __webpack_public_path__ + "img/goup.a27207f6.jpg";